<div class="errorPlaceholder">
  @if (errorMessage()) {
    <div class="errorMessage">
      <pre>{{ errorMessage() }}</pre>
    </div>
  }
</div>
<div class="content">
  <div class="tableWrapper">
    <div class="tagsTable" id="tagsTable"></div>
  </div>
  <div class="footer">
    <div class="buttonWrapper">
      <label class="instructionLabel">You can copy and paste information using standard keyboard shortcuts
        (CTRL + C to copy and CTRL + V to paste).
        You can also paste information from Excel.
      Rows can be inserted or removed via right-click menu options.</label>
      <span class="spacer"></span>
      <button class="dialogButton primary-button" matButton="elevated" (click)="save()">Save</button>
      <button class="dialogButton warn-button" matButton="elevated" (click)="cancel()">Cancel</button>
    </div>
  </div>
</div>
